!function () {
  'use strict';
  if (window.__cwWishlistKwikpassBridge) return;
  window.__cwWishlistKwikpassBridge = true;

  const LOGIN_REGEX = /\/account\/login|\/account\/register|\/customer_authentication\/login/i;
  const WLH_DIALOG_SELECTOR = '.MuiDialog-root:has(.wishlist-hero-header-title)';
  const KWIKPASS_SELECTORS =
    '[class*="kwikpass"], [id*="kwikpass"], [class*="gokwik"], [class*="GoKwik"], [class*="kp-login"]';

  function isVisible(el) {
    if (!el) return false;
    const s = getComputedStyle(el);
    return 'none' !== s.display && 'hidden' !== s.visibility && null !== el.offsetParent;
  }

  function isUserLoggedIn() {
    if (window.Theme?.customer?.loggedIn || window.Shopify?.customer?.id) return true;
    const loggedInIcons = document.getElementById('loggedin-icons');
    const kpLoginBtn = document.getElementById('kp-login-button-new-logo');
    return loggedInIcons && kpLoginBtn ? isVisible(loggedInIcons) && !isVisible(kpLoginBtn) : !(!loggedInIcons || !isVisible(loggedInIcons));
  }

  function resumeWishlistDialog() {
    document.body.removeAttribute('data-cw-kp-login-pending');
    document.querySelectorAll(`${WLH_DIALOG_SELECTOR}[data-cw-kp-suspended]`).forEach((dialog) => {
      dialog.removeAttribute('data-cw-kp-suspended');
      dialog.querySelectorAll('.MuiBackdrop-root').forEach((backdrop) => {
        backdrop.style.removeProperty('pointer-events');
      });
    });
  }

  let kpObserver = null;
  function watchKwikpassModal() {
    kpObserver?.disconnect();
    let modalFound = false;
    let timer = 0;
    kpObserver = new MutationObserver(() => {
      clearTimeout(timer);
      timer = window.setTimeout(() => {
        const modal = (function () {
          const inputs = document.querySelectorAll(
            'input[placeholder*="Mobile"], input[placeholder*="mobile"], input[type="tel"]'
          );
          for (const input of inputs) {
            if (!(input instanceof HTMLInputElement && isVisible(input))) continue;
            const container = input.closest(KWIKPASS_SELECTORS);
            if (container && isVisible(container)) return container;
          }
          return document.querySelector(KWIKPASS_SELECTORS);
        })();
        modal && isVisible(modal) && (modalFound = true);
        modalFound && !modal && (resumeWishlistDialog(), kpObserver?.disconnect(), (kpObserver = null));
      }, 300);
    });
    kpObserver.observe(document.body, { childList: true, subtree: true, attributes: true });
    window.setTimeout(() => {
      resumeWishlistDialog();
      kpObserver?.disconnect();
      kpObserver = null;
    }, 180000);
  }

  function handleKwikpassLogin() {
    if (typeof window.__cwWakeKwikpass === 'function') {
      window.__cwWakeKwikpass();
    }
    document.body.setAttribute('data-cw-kp-login-pending', 'true');
    document.querySelectorAll(WLH_DIALOG_SELECTOR).forEach((dialog) => {
      dialog.setAttribute('data-cw-kp-suspended', 'true');
      dialog.querySelectorAll('.MuiBackdrop-root').forEach((backdrop) => {
        backdrop.style.setProperty('pointer-events', 'none', 'important');
      });
    });
    let triggered = false;
    if ('function' == typeof window.kpHandleLogin) {
      window.kpHandleLogin();
      triggered = true;
    } else if ('function' == typeof window.handleKpAndShopifyLogin) {
      window.handleKpAndShopifyLogin();
      triggered = true;
    } else {
      const btn =
        document.getElementById('kp-login-button-new-logo') ||
        document.querySelector('[onclick*="handleKpAndShopifyLogin"], [onclick*="kpHandleLogin"]');
      if (btn instanceof HTMLElement) {
        btn.click();
        triggered = true;
      } else {
        const icon = document.querySelector('.icon.kp');
        if (icon instanceof HTMLElement) {
          icon.click();
          triggered = true;
        }
      }
    }
    return triggered ? watchKwikpassModal() : resumeWishlistDialog(), triggered;
  }

  function syncDialog(dialog) {
    if (!dialog) return;
    const loggedIn = isUserLoggedIn();
    dialog.querySelectorAll('.wishlist-hero-customer-view-listing, .wishlist-hero-list-header').forEach((banner) => {
      if (banner instanceof HTMLElement) {
        if (!banner.hasAttribute('data-cw-wlh-login-banner')) {
          banner.setAttribute('data-cw-wlh-login-banner', 'true');
        }
        if (loggedIn) {
          if (!banner.hidden) banner.hidden = true;
          if (banner.style.display !== 'none') banner.style.setProperty('display', 'none', 'important');
        } else {
          if (banner.hidden) banner.hidden = false;
          if (banner.style.display || banner.style.visibility) {
            banner.style.removeProperty('display');
            banner.style.removeProperty('visibility');
          }
        }
      }
    });
    dialog.querySelectorAll('a[href]').forEach((link) => {
      if (!(link instanceof HTMLAnchorElement)) return;
      const href = link.getAttribute('href') || '';
      if (href && LOGIN_REGEX.test(href) && 'true' !== link.dataset.cwKpLoginBound) {
        link.dataset.cwKpLoginBound = 'true';
        link.addEventListener(
          'click',
          (ev) => {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            handleKwikpassLogin();
          },
          true
        );
      }
    });
  }

  let lastLoggedIn = isUserLoggedIn();
  function syncState() {
    const loggedIn = isUserLoggedIn();
    if (document.body.hasAttribute('data-cw-user-logged-in') !== loggedIn) {
      document.body.toggleAttribute('data-cw-user-logged-in', loggedIn);
    }
    if (loggedIn !== lastLoggedIn) {
      lastLoggedIn = loggedIn;
      if (loggedIn && window.WishListHero_SDK?.GetWishListItemsFromServer) {
        window.WishListHero_SDK.GetWishListItemsFromServer().catch(() => {});
      }
    }
    const dialogs = document.querySelectorAll(WLH_DIALOG_SELECTOR);
    if (dialogs.length > 0) {
      dialogs.forEach(syncDialog);
    }
  }

  // Delegated click on Wishlist Hero login header buttons
  document.addEventListener(
    'click',
    (ev) => {
      const target = ev.target;
      if (!(target instanceof Element)) return;
      const loginBtn = target.closest('.wishlist-hero-list-header-login');
      if (loginBtn && loginBtn.closest(WLH_DIALOG_SELECTOR)) {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();
        handleKwikpassLogin();
      }
    },
    true
  );

  // Debounced/coalesced scheduler for syncState using requestAnimationFrame
  let rafScheduled = false;
  function scheduleSync() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(() => {
      rafScheduled = false;
      syncState();
    });
  }

  document.addEventListener('wishlist-hero-wishlist-sdk-ready', scheduleSync, false);

  // Filtered MutationObserver: only observe childList on document.body for relevant modal additions/removals
  const bodyObserver = new MutationObserver((mutations) => {
    let hasRelevantMutation = false;
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Element) {
          if (
            node.matches?.('.MuiDialog-root, [class*="MuiDialog"]') ||
            node.querySelector?.('.MuiDialog-root, [class*="MuiDialog"]') ||
            node.matches?.(KWIKPASS_SELECTORS) ||
            node.querySelector?.(KWIKPASS_SELECTORS)
          ) {
            hasRelevantMutation = true;
            break;
          }
        }
      }
      if (hasRelevantMutation) break;
      for (const node of mutation.removedNodes) {
        if (node instanceof Element) {
          if (
            node.matches?.('.MuiDialog-root, [class*="MuiDialog"]') ||
            node.querySelector?.('.MuiDialog-root, [class*="MuiDialog"]') ||
            node.matches?.(KWIKPASS_SELECTORS) ||
            node.querySelector?.(KWIKPASS_SELECTORS)
          ) {
            hasRelevantMutation = true;
            break;
          }
        }
      }
      if (hasRelevantMutation) break;
    }
    if (hasRelevantMutation) {
      scheduleSync();
    }
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: false,
  });

  if ('loading' === document.readyState) {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }
}();